<template>
  <div class="consulta-pontos">
    <header class="header">
      <h1 class="titulo">🛠 Ajuste Manual de Ponto</h1>
    </header>

    <!-- FILTROS -->
    <section class="filtro-section">
      <div class="filtro-grid">
        <div class="campo">
          <label>Funcionário</label>
          <select v-model="filtros.funcionario_id" class="input">
            <option disabled value="">Selecione</option>
            <option
              v-for="func in funcionariosLista"
              :key="func.id"
              :value="func.id"
            >
              {{ func.nome }}
            </option>
          </select>
        </div>

        <div class="campo">
          <label>Data</label>
          <input type="date" v-model="filtros.data" class="input" />
        </div>
      </div>

      <div class="acoes">
        <button class="btn-primario" @click="buscarRegistros">
          <i class="fas fa-search"></i> Buscar
        </button>
      </div>
    </section>

    <!-- LOADING -->
    <div v-if="loading" class="estado carregando">
      <div class="spinner"></div>
      <p>Carregando registros...</p>
    </div>

    <!-- CARD DO DIA -->
    <section v-else-if="registros.length" class="lista-dias">
      <div class="card-dia">
        <div class="cabecalho-dia">
          <h3>{{ formatDateTitle(filtros.data) }}</h3>
        </div>

        <div class="registros-container">
          <div
            v-for="reg in registros"
            :key="reg.id"
            class="registro-item"
          >
            <div class="registro-info">
              <select v-model="reg.registro_tipo" class="input-ajuste">
                <option value="ENTRADA">ENTRADA</option>
                <option value="PAUSA">PAUSA</option>
                <option value="SAIDA">SAÍDA</option>
              </select>

              <input
                type="time"
                v-model="reg.hora_editada"
                class="input-ajuste"
              />
            </div>

            <button
              class="btn-primario btn-salvar"
              @click="salvarAjuste(reg)"
            >
              💾 Salvar
            </button>
          </div>
        </div>

        <div class="acoes-bottom">
          <button class="btn-secundario" @click="adicionarRegistro">
            ➕ Novo Registro
          </button>
        </div>
      </div>
    </section>

    <div v-else class="estado vazio">
      <h3>Nenhum registro encontrado</h3>
    </div>
  </div>
</template>

<script>
import { adminService } from '@/services/adminService';

export default {
  name: 'AjustePonto',

  data() {
    return {
      funcionariosLista: [],
      registros: [],
      loading: false,
      filtros: {
        funcionario_id: '',
        data: ''
      }
    };
  },

  async mounted() {
    await this.carregarFuncionarios();
  },

  methods: {
    async carregarFuncionarios() {
      const response = await adminService.listFuncionarios();
      this.funcionariosLista = response.data;
    },

    async buscarRegistros() {
      if (!this.filtros.funcionario_id || !this.filtros.data) {
        alert('Selecione funcionário e data');
        return;
      }

      this.loading = true;

      try {
        const response = await adminService.getPontosPorDia(
          this.filtros.funcionario_id,
          this.filtros.data
        );

        this.registros = response.data.map(r => {
          const date = new Date(r.registro_timestamp);

          return {
            ...r,
            hora_editada: date.toTimeString().slice(0, 5)
          };
        });

      } catch (err) {
        alert('Erro ao buscar registros');
      } finally {
        this.loading = false;
      }
    },

    async salvarAjuste(reg) {
      try {
        const [hours, minutes] = reg.hora_editada.split(':').map(Number);
        const [year, month, day] = this.filtros.data.split('-').map(Number);

        const dataCompleta = new Date(year, month - 1, day, hours, minutes);

        const timezoneOffset = dataCompleta.getTimezoneOffset();
        const dataCorrigida = new Date(dataCompleta.getTime() - timezoneOffset * 60000);
        const dataISO = dataCorrigida.toISOString();

        await adminService.ajustarRegistro({
          registro_id: reg.id,
          registro_tipo: reg.registro_tipo,
          registro_timestamp: dataISO
        });

        alert('Registro atualizado com sucesso!');
      } catch (err) {
        alert('Erro ao salvar ajuste');
      }
    },

    adicionarRegistro() {
      this.registros.push({
        id: null,
        registro_tipo: 'ENTRADA',
        hora_editada: '08:00'
      });
    },

    formatDateTitle(dataStr) {
      const [year, month, day] = dataStr.split('-');
      const date = new Date(year, month - 1, day);
      return date.toLocaleDateString('pt-BR', {
        weekday: 'long',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    }
  }
};
</script>

<style scoped>
.registros-container {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.registro-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8fafc;
  padding: 0.8rem 1rem;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
}

.registro-info {
  display: flex;
  gap: 0.6rem;
}

.input-ajuste {
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 0.4rem 0.6rem;
  font-size: 0.9rem;
  background: white;
}

.input-ajuste:focus {
  border-color: #3b82f6;
  outline: none;
  box-shadow: 0 0 0 2px rgba(59,130,246,0.2);
}

.btn-salvar {
  padding: 0.4rem 0.8rem;
  font-size: 0.85rem;
}

.acoes-bottom {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
}

</style>